import { common } from '../../main/common-sidecar'
import { voyageBackground_starfield } from './voyageBackground_starfield-sidecar'

export function create() {
  voyageBackground_starfield.reset()
}

export function update() {
  let ds = common.getUpdateDeltaScaled()

  voyageBackground_starfield.updateAll()
}
